<template>
    <div class="user__admin">
            <div class="upload__container users flex">
            Użytkownicy:
            <div class="users__loader">
                <Spinner
                    v-show="!users"
                ></Spinner>
                <span class="users__info"
                    v-show="usersInfo"
                >{{ usersInfo }}</span>
            </div>
            <ul v-show="users">
                <li class="flex user"
                    v-for="user in users" :key="user._id"
                >
                    <div class="user__name">
                        {{user.name}}
                    </div>
                    <div class="user__role">
                        {{user.role}}
                    </div>
                    <div class="user__delete"
                        @click="userMessage(user)"
                    >
                        <Delete>
                            Usuń
                        </Delete>
                    </div>
                </li>
            </ul>
            <div class="users__message"
                v-if="usersMessage"
            >
                <div class="post__message__text">
                    Czy chcesz usunąć użytkownika {{ userToRemove.name }}?
                </div>
                <div class="post__message__buttons">
                    <button class="btn"
                        @click="removeUser(userToRemove._id)"
                    >Tak</button>
                    <button class="btn btn-reverse"
                        @click="hideUsersMessage"
                    >Nie</button>
                </div>
            </div>
        </div>
        <div class="upload__container flex">
            <div class="upload__container flex"
                v-if="showAddUser"
            >
                <label>Dodaj użytkownika:<span>*</span></label>
                <input
                v-model="user.username"
                >
                <label>Adres e-mail:</label>
                <input
                    v-model="user.email"
                >
                <label>Hasło:<span>*</span></label>
                <input
                    v-model="user.password"
                >
                <label>Powtórz hasło:<span>*</span></label>
                <input
                    v-model="user.passwordConf"
                >
                <label>Wybierz rodziaj użytkownika:<span>*</span></label>
                <select v-model="user.role">
                    <option>Gość</option>
                    <option>Admin</option>
                </select>
                <div class="upload__info">
                    {{ user.info }}
                </div>
            </div>
            <button class="btn"
                @click="(showAddUser) ? addUser() : showAddUser = true"
            >
                <span
                    v-if="!user.saving"
                >Dodaj użytkownika</span>
                <span class="spinner__container flex"
                    v-if="user.saving"
                >
                    <Spinner
                        :size="20"
                        :color="color"
                    ></Spinner>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import Delete from '@/assets/img/trash-alt-regular.svg'
import get from '@/utils/get'
import deleteUser from '@/utils/deleteUser'
import saveUser from '@/utils/saveUser'

export default {
    components: {
        Delete
    },
    data(){
        return {
            userToRemove: {},
            usersMessage: false,
            users: {},
            user: {
                username:'',
                password:'',
                passwordConf:'',
                email:'',
                saving: false,
                info:'',
                role: ''
            },
            usersInfo: '',
            showAddUser: false,
        }
    },
    mounted(){
        this.loadUsers();
    },
    methods: {
        async loadUsers(){
            const users = await get(this.$store.state.token, 'users/get');

            this.users = users;
        },
        async removeUser(id){

            const response = await deleteUser(this.$store.state.token, id);

            if(response.success === true){
                const removeUser = this.users.filter(user => {
                        return user._id != id
                    })
                this.usersInfo = response.message;
                this.users = removeUser;
                this.hideUsersMessage();
            } else {
                this.usersInfo = response.message;
            }
        },
        async addUser(){
            let {username, password, passwordConf, role} = this.user;

            this.saving = true;

            if(username && password &&  passwordConf && role) {
                if(password === passwordConf){
                    const user = await saveUser(this.$store.state.token, this.user)

                    this.saving = false;
                    this.user.info = `Utworzono użytkownika o nazwie ${user.name}`;
                    this.usersInfo = 'Użytkownik został dodany';
                    this.users.push(user);
                    this.user = {};
                } else {
                    this.user.info = 'Wpisane hasła muszą być identyczne.'
                    this.saving = false;
                }
            } else {
                this.user.info = 'Wymagane pola muszą zostać wypełnione'
                this.saving = false
            }
        },
        userMessage(user){
            this.usersMessage = true;
            this.userToRemove = user;
        },
        hideUsersMessage(){
            this.usersMessage = false;
        },
    }
}
</script>
